






















import { Component, Prop, Vue } from 'vue-property-decorator';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import Form, {
  InputData,
  OnSubmitReturn,
} from '@/main-components/common/Form.vue';

@Component({
  components: {
    Form,
  },
})
export default class SignupNew extends Vue {
  @Prop({ default: false })
  notSignupPage: boolean;

  @Prop({ default: false })
  hideSignin: boolean;

  userStore: UserStoreInterface = UserStore;

  isLoading = false;

  inputs: InputData[] = [
    {
      name: 'email',
      value: '',
      placeholder: 'Emel anda',
      type: 'text',
      isRequired: true,
      isEmail: true,
    },
    {
      name: 'phoneNumber',
      value: '',
      placeholder: 'Nombor telefon e.g. 0123754239',
      type: 'text',
      isRequired: true,
    },
    {
      name: 'role',
      value: '',
      placeholder: 'Pilih kategori anda ',
      type: 'dropdown',
      isRequired: true,
      dropdownOptions: [
        {
          value: 'teacher',
          text: 'Guru',
          isSelected: false,
        },
        {
          value: 'student',
          text: 'Murid',
          isSelected: false,
        },
        {
          value: 'parent',
          text: 'Ibu Bapa',
          isSelected: false,
        },
      ],
    },
    {
      name: 'password',
      value: '',
      placeholder: 'Kata laluan',
      type: 'password',
      isRequired: true,
      hasMinimum: 6,
    },
  ];

  get redirectTo(): string {
    if (typeof this.$route.query.redirect === 'string') {
      return this.$route.query.redirect.trim();
    } else {
      return '';
    }
  }

  async signupSubmitted(bodyRequest: any): Promise<OnSubmitReturn | null> {
    if (this.isLoading) return null;
    this.isLoading = true;

    const hasErrorRegister = await this.registerUser(bodyRequest);
    if (hasErrorRegister) {
      this.isLoading = false;
      return hasErrorRegister;
    }

    this.isLoading = false;

    return null;
  }

  async registerUser(bodyRequest: any) {
    const firstName = bodyRequest.email.split('@')[0];

    await this.userStore.signup({
      firstName,
      lastName: '',
      ...bodyRequest,
    });

    if (
      this.userStore.error &&
      this.userStore.error.code === 'email_already_in_used'
    ) {
      this.userStore.error.message = 'E-mel sudah digunakan';

      this.$sendMpEvent({
        event: this.$mp_value.ErrorSignup,
        properties: {
          error: this.userStore.error.message,
          email: bodyRequest ? bodyRequest.email : '',
        },
      });

      return { error: this.userStore.error };
    } else if (
      this.userStore.error &&
      this.userStore.error.code === 'phone_number_already_in_used'
    ) {
      this.userStore.error.message = 'Nombor telefon sudah digunakan';

      this.$sendMpEvent({
        event: this.$mp_value.ErrorSignup,
        properties: {
          error: this.userStore.error.message,
          phone: bodyRequest ? bodyRequest.phoneNumber : '',
        },
      });

      return { error: this.userStore.error };
    } else {
      this.$sendMpEvent({
        event: this.$mp_value.Signup,
        properties: {
          email: bodyRequest.email,
          phoneNumber: bodyRequest.phoneNumber,
        },
      });
      await this.userStore.signin(bodyRequest);
      this.redirectUser();
    }

    return null;
  }

  redirectUser() {
    if (this.notSignupPage) {
      this.$router.go(0);
    } else if (this.redirectTo) {
      this.$router.push({
        path: this.redirectTo,
      });
    } else {
      this.$router.push({
        name: 'browse',
      });
    }
  }

  signinClick() {
    this.$router.push({
      path: '/signin',
    });
  }
}
